import { get } from 'lodash-es';

import { TransactionCategory } from '@shipstation/financial-services-ui-components';
import { emptyArray } from 'ui-components/default-props/empty';

import type { PaymentMethodDetails } from '../../financial-services-ui/types/fsui';
import type { RootState } from 'store/root-state';
import type { PaymentMethodsState } from './payment-methods.types';

const selectPaymentMethods = (state: PaymentMethodsState): PaymentMethodDetails[] =>
  get(state, 'paymentMethods', emptyArray as PaymentMethodDetails[]);

const selectHasActiveShipmentInvoicePayment = (state: PaymentMethodsState): boolean =>
  selectPaymentMethods(state).some((pm) => pm.assignedPreferences?.includes(TransactionCategory.Freight));

export const selectPaymentMethodsPaymentMethods = (state: RootState): PaymentMethodDetails[] =>
  selectPaymentMethods(get(state, 'paymentMethods') as unknown as PaymentMethodsState);

export const selectPaymentMethodsHasActiveShipmentInvoicePayment = (state: RootState): boolean =>
  selectHasActiveShipmentInvoicePayment(get(state, 'paymentMethods') as unknown as PaymentMethodsState);
